import { SHOW_SPEEDS } from "src/utils/roundMotion"

/* The speed a round's show plays at (requirement 36, M10), per browser like the grid eye: x1 until
   the player picks another. Storage that throws or holds anything else reads as x1. */
const KEY = "hvz-show-speed"

export const loadShowSpeed = () => {
  try {
    const stored = Number(localStorage.getItem(KEY))
    return SHOW_SPEEDS.includes(stored) ? stored : 1
  } catch {
    return 1
  }
}

export const saveShowSpeed = (speed) => {
  try {
    localStorage.setItem(KEY, String(speed))
  } catch {
    // Storage unavailable: the choice lives for this session only.
  }
}
